import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Snackbar from '../../../labels/Snackbar';
import BlueButton from '../../../buttons/BlueButton';
import Loading from '../../../dialogs/loading';


class MenuValue extends React.Component {

    state = {
        report_decrease: undefined
    }

    static getDerivedStateFromProps(props, state) {
        const { report_decrease } = props;
        if (report_decrease !== state.report_decrease) {
            state.report_decrease = report_decrease;
            state.local = report_decrease.local;
            state.from = report_decrease.from;
            state.to = report_decrease.to;
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (event) => {
        const { local, from, to } = this.state;
        this.props
            .loadInfoDecrease(
                local ? [local] : this.props.locals.filter((l) => l.configurado === 3).map((lo) => lo.id),
                from,
                to
            )
            .then(() => this.props.history.push('/reports/decrease/result'))
            .catch((error) => {
                this.setState({ error: error.message });
            });
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleCloseError = () => {
        this.setState({ error: '' });
    }

    render() {
        const {
            local,
            from,
            to,
            error
        } = this.state;
        const { intl, locals, locals_is_loading } = this.props;

        return (
            <div className={'width50 padding_bottom_9'}>
                {locals_is_loading && <Loading open opacity />}
                <div className="padding_borders_flat">
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {locals &&
                                    locals
                                        .filter((local) => local.configurado === 3)
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((local) => {
                                            return (
                                                <option key={randomstring()} value={local.id}>
                                                    {local.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            defaultValue={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            defaultValue={to}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center" />
                    <BlueButton id="search" onClick={this.handleSearch} />
                    <div />
                </div>
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired
};



export default injectIntl(MenuValue);



// WEBPACK FOOTER //
// ./src/components/complex/reports/decrease/Menu.js